import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { toast } from 'react-toastify';
import api from '@services/api';

const MeetingEvaluation = ({
  meetingId,
  initialRating,
  initialMeetingOccurred,
  evaluatedId,
  evaluatedType,
  evaluatorId,
  evaluatorType,
  evaluatorUuid
}) => {
  const [rating, setRating] = useState(initialRating || null);
  const [meetingOccurred, setMeetingOccurred] = useState(
    initialMeetingOccurred
  );

  const handleSubmit = async () => {
    try {
      const response = await api.post('/public/meetings/evaluate', {
        meeting_id: meetingId,
        evaluated_id: evaluatedId,
        evaluated_type: evaluatedType,
        evaluator_id: evaluatorId,
        evaluator_type: evaluatorType,
        evaluator_uuid: evaluatorUuid,
        rating,
        meeting_occurred: meetingOccurred // Envoyer la valeur actuelle
      });

      if (response.data.success) {
        toast('Évaluation enregistrée avec succès.');
      } else {
        toast("Erreur lors de l'enregistrement de l'évaluation.");
      }
    } catch (error) {
      console.error("Erreur lors de l'enregistrement de l'évaluation:", error);
      toast('Une erreur est survenue.');
    }
  };

  return (
    <div className="meeting-evaluation">
      <p>
        <strong>Le rendez-vous a-t-il eu lieu ?</strong>
      </p>
      <div className="meeting-occurred-buttons">
        <button
          className={`btn ${
            meetingOccurred === true ? 'btn-success' : 'btn-outline-success'
          }`}
          onClick={() => setMeetingOccurred(true)}
          style={{ marginRight: '10px' }}
        >
          Oui
        </button>

        {/* Bouton "Non" */}
        <button
          className={`btn ${
            meetingOccurred === false ? 'btn-danger' : 'btn-outline-danger'
          }`}
          onClick={() => setMeetingOccurred(false)}
        >
          Non
        </button>
      </div>
      <div style={{ marginTop: '10px' }}>
        <p>
          <strong>Évaluer la qualité du rendez-vous :</strong>
        </p>
        <div>
          {[1, 2, 3, 4, 5].map(star => (
            <span
              key={star}
              onClick={() => setRating(star)}
              style={{
                cursor: 'pointer',
                color: rating >= star ? 'gold' : 'gray',
                fontSize: '1.5rem',
                marginRight: '5px'
              }}
            >
              ★
            </span>
          ))}
        </div>
      </div>
      <button onClick={handleSubmit} className="btn btn-primary mt-2">
        Enregistrer
      </button>
    </div>
  );
};

MeetingEvaluation.propTypes = {
  meetingId: PropTypes.string.isRequired,
  initialRating: PropTypes.number,
  initialMeetingOccurred: PropTypes.bool, // Ajout de la prop pour initialiser l'état
  evaluatedId: PropTypes.number.isRequired,
  evaluatedType: PropTypes.string.isRequired,
  evaluatorId: PropTypes.string.isRequired,
  evaluatorType: PropTypes.string.isRequired,
  evaluatorUuid: PropTypes.string.isRequired
};

export default MeetingEvaluation;
